import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-invoice-print',
  templateUrl: './invoice-print.component.html',
  styleUrls: ['./invoice-print.component.css'],
  standalone: false
})
export class InvoicePrintComponent implements OnInit {

  @Input() public vm: any;

  constructor() { }

  ngOnInit() {
  }

}
